<template>
  <div class="app-box padding-top-20 padding-left-30 padding-right-30">
    <div class="page-title line">
      {{ $t('message.payee.addPayeeAccountInfo') }}
    </div>
    <div class="payee-layout">
      <div class="payee-left-margin payee-item">
        <div class="details-title  padding-bottom-20">
          {{ $t('message.payee.essentialInformation') }}
        </div>
        <span class="payee-img-wrap margin-right-30">
             <img v-if="frontPhotoUrl" class="payee-img" :src="frontPhotoUrl" alt="">
        </span>
        <span class="payee-img-wrap">
             <img v-if="reversePhotoUrl" class="payee-img" :src="reversePhotoUrl" alt="">
        </span>
        <details-component v-if="detailsData"
                           :row-column="2"
                           :details-condition="payeeInfoCondition">
        </details-component>
      </div>
      <div class="payee-item">
        <div class="details-title  padding-bottom-20">
          {{ $t('message.payee.payeeAccount') }}
        </div>
        <details-component v-if="detailsData"
                           :row-column="2"
                           :details-condition="payeeCardCondition">
        </details-component>
      </div>
    </div>

  </div>
</template>
<script>
import { GetCityList, GetProvinceList } from '@/api/common/provinces-cities';
import DetailsComponent from '@/components/base-details/details.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import PayeeManageService from '@/views/settlement/api/settlement-payee';
import { GenderStatus, ProfessionStatus } from '@/views/settlement/payee-manage/status/payee';

export default {
  components: { DetailsComponent },
  data() {
    return {
      detailsData: {},
      frontPhotoUrl: '',
      reversePhotoUrl: '',
      payeeInfoCondition: [{
        topTitle: '',
        type: 'default',
        listTemplate: [
          {
            titleBar: { title: 'message.payee.identificationNumber' },
            key: 'idNumber',
            span: 2,
          },
          {
            titleBar: { title: 'message.transaction.name' },
            key: 'name',
          },
          {
            titleBar: { title: 'message.payee.namePinyin' },
            key: 'spell',
          },
          {
            titleBar: { title: 'message.payee.gender' },
            key: 'gender',
            isInternationalization: true,
            textFunc: (data) => getEnantiomericValue(GenderStatus, data.gender),
          },
          {
            titleBar: { title: 'message.payee.birthday' },
            key: 'birthDate',
          },
          {
            titleBar: { title: 'message.payee.effectiveDate' },
            key: 'effectiveDate',
          },
          {
            titleBar: { title: 'message.payee.expireDate' },
            key: 'expireDate',
          },
          {
            titleBar: { title: 'message.payee.nationality' },
            key: 'nationality',
            span: 2,
          },
          {
            titleBar: { title: 'message.payee.occupation' },
            key: 'profession',
            span: 2,
            isInternationalization: true,
            textFunc: (data) => getEnantiomericValue(ProfessionStatus, data.profession),
          },
          {
            titleBar: { title: 'message.transaction.address' },
            key: 'address',
            span: 2,
          },
        ],
        data: null,
      }],
      payeeCardCondition: [{
        topTitle: '',
        type: 'default',
        listTemplate: [
          {
            titleBar: { title: 'message.payee.bankAddress' },
            key: 'bankAddress',
            textFunc: (data) => getEnantiomericValue(GetProvinceList(), data.province),
          },
          {
            titleBar: { title: '' },
            key: 'name',
            textFunc: (data) => getEnantiomericValue(GetCityList(data.province), data.city),
          },
          {
            titleBar: { title: 'message.payee.bankName' },
            key: 'bankName',
            span: 2,
          },
          {
            titleBar: { title: 'message.payee.bankAccount' },
            key: 'bankAccount',
            span: 2,
          },
          {
            titleBar: { title: 'message.payee.cardNumber' },
            key: 'cardNumber',
            span: 2,
          },
          {
            titleBar: { title: 'message.payee.mobilePhone' },
            key: 'phone',
            span: 2,
          },
        ],
        data: null,
      }],
    };
  },
  methods: {
    ...PayeeManageService,
    initDetailsAll() {
      this.getPayeeInfo({ cardInfoId: this.$route.query.cardInfoId }).then((data) => {
        this.payeeInfoCondition[0].data = data;
        this.payeeCardCondition[0].data = data;
        this.detailsData = data;
        if (data.idCardFront) {
          this.getImageFile({ url: data.idCardFront }).then(data => {
            this.frontPhotoUrl = data;
          });
        }
        if (data.idCardReverse) {
          this.getImageFile({ url: data.idCardReverse }).then(data => {
            this.reversePhotoUrl = data;
          });
        }
      });
    },
  },
  created() {
    this.initDetailsAll();
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.payee-layout {
  display: flex;
  flex-direction: row;

  .payee-item {
    width: 420px;
  }

  .payee-left-margin {
    margin-right: 20%;
  }

  .el-card {
    border: 0px;
  }

  .el-descriptions-item__label::after {
    content: ' ';
  }
}

.payee-img-wrap {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 148px;
  height: 148px;
  border-radius: 6px;
  border: 1px solid #A4AFBF;
}

.payee-img {
  position: absolute;
  width: 98%;
  height: 98%;
  border-radius: 6px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
